import { versionDate } from './versionDate';

export const environment = {
  environmentType: 'dev',
  localDomain: 'https://dev.safety.goadroit.com',
  apiUrl: 'https://dev.safety-api.goadroit.com/v1/safety',
  mainapiUrl: 'https://dev.safety-api.goadroit.com/v1/safety',
  client_id:
    '783896173032-91afo3riksqg88mm8ffh2cjns3f0rtl6.apps.googleusercontent.com',
  microsoft_client_id: 'ced88beb-2017-4469-acda-4a105c49a819',
  redirect_uri: 'https://dev.safety.goadroit.com/login',
  logout_redirect_uri: 'https://dev.safety.goadroit.com/logout',
  clientUrl: 'https://dev.safety.goadroit.com',
  isLocal: false,

  versionDate,
};
